import { render } from "./PaymentWidget.vue?vue&type=template&id=5e170c32&scoped=true"
import script from "./PaymentWidget.vue?vue&type=script&lang=js"
export * from "./PaymentWidget.vue?vue&type=script&lang=js"

import "./PaymentWidget.vue?vue&type=style&index=0&id=5e170c32&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e170c32"]])

export default __exports__